import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const cropsByFarmRoom = createAsyncThunk('cropsByFarmRoom', async ({ farm_id, room_id, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + 'work-farm-crops/dropdown/crops-by-farm-room',
            params: { farm_id, room_id },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const cropsByFarmRoomSlice = createSlice({
    name: 'cropsByFarmRoom',
    initialState: {
        data: [],
    },
    reducers: {
        clearCropsByFarmRoom: (state) => {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(cropsByFarmRoom.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(cropsByFarmRoom.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export const { clearCropsByFarmRoom } = cropsByFarmRoomSlice.actions;
export default cropsByFarmRoomSlice.reducer;
